module.exports = __webpack_public_path__ + "static/media/2_2kim.360d02cc.png";